export default __webpack_public_path__ + "static/kalajamun-4769a48d2a105d2fc892f6c73cfa27c1.png";